'use client';

import React, { useState } from 'react';
import Image from 'next/image';

export default function ImageWithFallback({
  srcOrigin,
  srcFallback,
  alt,
  width,
  height,
  className = '',
}: {
  srcOrigin: string;
  srcFallback: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
}): React.JSX.Element {
  const [loaded, setLoaded] = useState(true);

  return (
    <>
      <Image
        alt={alt}
        className={className}
        height={height}
        onError={() => {
          setLoaded(false);
        }}
        src={srcOrigin}
        style={loaded ? {} : { display: 'none', width, height }}
        width={width}
      />

      {loaded ? null : (
        <img alt={alt} className={className} src={srcFallback} />
      )}
    </>
  );
}
